// extracted by mini-css-extract-plugin
module.exports = {"repeat":"styles_repeat__JJmye","seconds":"styles_seconds__7OEnh","send":"styles_send__qOzmr","sent":"styles_sent__U7PL7","error":"styles_error__Y0AGY"};